import React from 'react';
import PropTypes from 'prop-types';
import { dayMonthYear } from "../../utils/dates";
import Box from "../Box/Box";
import TimelineGroup from "../Timeline/TimelineGroup";
import TimelineGroupItem from "../Timeline/TimelineGroupItem";
import Timeline from "../Timeline/Timeline";
import InfinityScrollList from '../List/InfinityScrollList';

class AssetTimeline extends React.Component {

  constructor(props) {
    super(props);
  }

  sortByStateDate (content) {
    return content.sort((a, b) => new Date(a.stateDate).getTime() > new Date(b.stateDate).getTime() ? -1 : 1)
  }

  possibleDirectionTranslate(possibleDirection){
    switch (possibleDirection) {
      case "IN" :
        return "Entrada";
      case "OUT" :
        return "Saída"
    }
  }
  render() {

    const TextBold = ({ title, content }) => {
      return (
        <h5>
          <b>{title}</b>: {content}
        </h5>
      )
    }

    return (
      <Box info title="Timeline">
        <Timeline>
          <InfinityScrollList
            pageSize={20}
            key={this.props.epc}
            endpoint={`ton/v1/assets/epcs/${this.props.epc}/states`}
            emptyListMessage="Este produto ainda não foi movimentado."
            addParams={params => params.append('sort' , 'stateDate,DESC')}
            onData={this.sortByStateDate}
            groupBy={e => dayMonthYear(e.stateDate)}
            groupSeparator={content => <TimelineGroup date={dayMonthYear(content.stateDate)} />}
            renderItems={({ lsd, user, checkpoint, readpoint, stateDate, comment, index, possibleDirection }) => {
              let icon


              const modState = index % 2;

              if (readpoint && readpoint.type === 'COMMISSIONER') {
                icon = 'fa-tag bg-blue';
              } else {
                if (modState === 1) {
                  icon = 'fa-sign-out bg-purple';
                } else {
                  icon = 'fa-sign-in bg-maroon';
                }
              }

              return (
                <TimelineGroupItem date={stateDate} header={lsd && lsd.bizLocation.friendlyName} icon={icon}>
                  <TextBold title="Ponto de Leitura" content={readpoint && readpoint.friendlyName}/>
                  <TextBold title="Ponto de Controle" content={checkpoint && checkpoint.friendlyName}/>
                  <TextBold title="Usuário" content={user && user.name}/>
                  <TextBold title="Disposição" content={lsd && lsd.disposition.friendlyName}/>
                  <TextBold title="Etapa" content={lsd && lsd.bizStep.friendlyName}/>
                  <TextBold title="Vaga" content={lsd && lsd.polygonFriendlyName}/>
                  <TextBold title="Possível direção" content={this.possibleDirectionTranslate(possibleDirection)}/>
                  {comment && <TextBold title="Comentário" content={comment}/>}
                </TimelineGroupItem>
              )
            }}
          />
        </Timeline>
      </Box>
    );
  }
}

AssetTimeline.propTypes = {
  epc: PropTypes.string,
  tagId: PropTypes.string
};

export default AssetTimeline;



// WEBPACK FOOTER //
// ./src/component/Asset/AssetTimeline.js